define('ShareCart.Model', [
    'ProductList.Item.Collection',
    'Backbone',
    'underscore',
    'Utils'
], function ShareCartModel(
    ProductListItemCollection,
    Backbone,
    _,
    Utils
) {
    'use strict';

    var FixedProductListItemCollection = ProductListItemCollection.extend({
        initialize: function initialize() {}
    });

    return Backbone.Model.extend({
        urlRoot: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/ShareCart.Service.ss')),
        initialize: function initialize() {
            this.on('change:items', function onChange(model, items) {
                model.set('items', new FixedProductListItemCollection(items), {
                    silent: true
                });
            });
        },
        validation: {
            email: {
                required: true,
                pattern: 'email',
                msg: _('Please provide a valid email').translate()
            }
        }
    });
});
